<template>
  <div class="interactive-input d-flex align-items-end" :class="[{focused: inputFocused}, {error:error}]">
    <i :class="icon" class="input-icon"></i>
    <div class="w-100">
      <label :for="formLabel.toLowerCase()" class="m-0 input-label" :class="{focused: inputFocused || formAttr.modelValue.length}">{{formLabel}}</label>
      <jet-input 
        :value="modelValue"
        ref="input"
        :class="formAttr.classes" 
        :type="formAttr.type" 
        :id="formAttr.id" 
        :required="formAttr.required"
        :autofocus="formAttr.autofocus"
        @focus="inputFocused = true"
        @blur="inputFocused = false"
        @input="$emit('update:modelValue', $event.target.value)"></jet-input>
    </div>
  </div>
</template>

<script>
  import JetInput from '@/Jetstream/Input'

  export default {
    emits: ['update:modelValue'],
    data() {
      return {
        inputFocused: false
      }
    },
    components: {
      JetInput
    },
    props: {
      modelValue: String,
      formLabel: String,
      icon: String,
      formAttr: Object,
      error: [Boolean, Number]
    },
  }
</script>
